import AvailabilityModal from './AvailabilityModal'

export default AvailabilityModal
